<template>
  <b-card :class="{ 'h-100': !isPreview, 'mx-0': true, 'content-card': true }" no-body>
    <b-card-header class="bg-white p-0">
      <div class="position-relative" style="height: 230px;" v-if="entry.image && entry.image.fileLocation">
        <img class="w-100 h-100 rounded-0" :src="entry.image.fileLocation" :alt="entry.title"
          style="object-fit: cover; object-position: top;" />
      </div>
      <div class="position-relative" style="height: 230px;" v-else-if="entry.imageURL">
        <img class="w-100 h-100 rounded-0" :src="entry.imageURL" :alt="entry.title"
          style="object-fit: cover; object-position: top;" />
      </div>
    </b-card-header>

    <b-card-body>
      <b-card-title>
        <a v-if="(!entry.content || !entry.content.length) && entry.url" class="text-black mr-2" :href="entry.url"
          target="_blank">{{ entry.title }}</a>
        <a v-else class="text-black mr-2" v-b-modal="`content-share-view-${entry.id}`">{{ entry.title }}</a>
        <span v-if="entry.campaign" class="py-1 px-3 campaign-label"
          :style="{ backgroundColor: entry.campaign.branding ? entry.campaign.branding.colour : '#aaa' }">{{
            entry.campaign.title }}</span>
      </b-card-title>
      <key-stats :contentShare="entry" iconSize="lg" />
      <b-card-text v-if="entry.description">{{ entry.description }}</b-card-text>
    </b-card-body>

    <template v-if="hideFooter === false">
      <b-card-footer class="bg-white border-0 d-flex justify-content-end align-items-center">
        <b-btn v-if="(!entry.content || !entry.content.length) && entry.url" :href="entry.url" target="_blank"
          variant="outline-primary" class="mr-3">
          {{ $t('contentShares.card.view-cta') }}
          <font-awesome-icon icon="eye" />
        </b-btn>
        <b-btn v-else v-b-modal="`content-share-view-${entry.id}`" variant="outline-primary" class="mr-3">
          {{ $t('contentShares.card.view-cta') }}
          <font-awesome-icon icon="eye" />
        </b-btn>
        <!-- b-btn
          class="mr-2"
          v-if="isEY && (defaultShareURL || shareUrl)"
          variant="primary"
          :href="`https://api.qrserver.com/v1/create-qr-code/?data=${shareUrl || defaultShareURL}&size=500x500`"
          target="_blank"
        >
          QR Code
        </b-btn -->

        <!-- show only Linkedin button for picnic or olx -->
        <span v-if="isPicnic || isOLX">
          <b-btn
          v-b-modal="isLiConnected ? `content-share-linkedin-post-editor-${entry.id}` : `connect-linkedin-${entry.id}`"
          variant="primary">
          {{ $t('contentShares.card.share-on-li-cta') }}
          <font-awesome-icon icon="share" />
        </b-btn>
        </span>
        <span v-else>
          <b-btn
            v-if="hasContentSharesV2Enabled && [ 'image', 'video', 'document' ].includes(postType)"
            v-b-modal="isLiConnected ? `content-share-linkedin-post-editor-${entry.id}` : `connect-linkedin-${entry.id}`"
            variant="primary">
            {{ $t('contentShares.card.share-on-li-cta') }}
            <font-awesome-icon icon="share" />
          </b-btn>
          <b-btn
            v-else="defaultShareURL && ['link'].includes(postType)"
            v-b-modal="`content-share-${entry.id}`" variant="primary">
            {{ $t('contentShares.card.share-cta') }}
            <font-awesome-icon icon="share" />
          </b-btn>
        </span>
      </b-card-footer>

      <!-- Share Modal -->
      <b-modal :id="`content-share-${entry.id}`" hide-header hide-footer lazy v-if="defaultShareURL">
        <share :title="$t('contentShares.card.share-title')" :url="shareUrl || defaultShareURL" show-preview
          :preview-text="shareText || '{contentTitle}'" :preview-args="{ contentTitle: entry.title }"
          :providers="canShareJobsWith" @modal-close="() => $bvModal.hide(`content-share-${entry.id}`)" source="content"
          @track="data => $emit('trackShare', data)"
          @openLinkedInConnectionModal="$bvModal.show(`connect-linkedin-${entry.id}`)"
          @openLinkedInPostModal="$bvModal.show(`content-share-linkedin-post-editor-${entry.id}`)"
          @openFacebookConnectionModal="$bvModal.show(`connect-facebook-${entry.id}`)" :postType="postType">
          <template v-slot:text>
            <p>{{ $t('contentShares.card.share-text') }}</p>
          </template>
        </share>
      </b-modal>

      <!-- Connect LinkedIn Modal -->
      <b-modal title="Connect LinkedIn" :id="`connect-linkedin-${entry.id}`" v-if="hasContentSharesV2Enabled"
        hide-footer @close="cleanupRoute()">
        <ConnectLinkedIn :entryID="entry.id" />
      </b-modal>

      <!-- LinkedIn Post Editor Modal -->
      <b-modal :id="`content-share-linkedin-post-editor-${entry.id}`" hide-footer title="Edit LinkedIn Post"
        no-close-on-backdrop no-close-on-esc :hide-header="hideHeader"
        @close="cleanupRoute()">
        <LinkedInPostEditor :contentShare="entry" :campaignID="campaignID" @track="data => $emit('trackShare', data)" />
      </b-modal>

      <!-- Connect Facebook Modal -->
      <b-modal title="Connect Facebook" :id="`connect-facebook-${entry.id}`" v-if="hasFacebookShareV2Enabled"
        hide-footer>
        <ConnectFacebook :entryId="entry.id" />
      </b-modal>

      <!-- View Modal -->
      <b-modal :id="`content-share-view-${entry.id}`" :title="$t('campaign-admin.titles.content')" hide-footer lazy
        v-if="entry">
        <h2 v-if="entry.title" class="mb-4 mt-2">{{ entry.title }}</h2>
        <div v-if="(entry.image && entry.image.fileLocation) || entry.imageURL"
          class="mb-3 d-flex justify-content-center align-items-center" style="background: #444">
          <img v-if="entry.image && entry.image.fileLocation" style="max-height: 300px" :src="entry.image.fileLocation"
            :alt="entry.title" />
          <img v-else-if="entry.imageURL" style="max-height: 300px" :src="entry.imageURL" :alt="entry.title" />
        </div>
        <rich-text-content v-if="entry.content" class="mb-4" :value="entry.content" />
      </b-modal>

      <slot name="footer" />
    </template>
  </b-card>
</template>

<script>
import KeyStats from '@/components/content-share/KeyStats';
import Share from '@/components/Share';
import ConnectLinkedIn from '@/components/content-share/ConnectLinkedIn';
import LinkedInPostEditor from '@/components/content-share/LinkedInPostEditor';
import { mapPreferences, mapRoot } from '@/mixins/root';
import { RichTextContent } from '@/components/RichTextField';
import ConnectFacebook from '@/components/content-share/ConnectFacebook.vue';

export default {
  props: {
    entry: {
      type: Object,
    },
    shareUrl: {
      type: String,
      default: null,
    },
    hideFooter: {
      type: Boolean,
      default: () => false,
    },
    isPreview: {
      type: Boolean,
      default: () => false,
    },
    campaignID: {
      type: String,
      default: null,
    },
  },
  components: {
    Share,
    KeyStats,
    RichTextContent,
    LinkedInPostEditor,
    ConnectLinkedIn,
    ConnectFacebook
  },
  methods: {
    cleanupRoute() {
      if (this.$router.history && this.$router.history.current && this.$router.history.current.query) {
        // refresh the page if we open the card from a comm message
        if (this.$router.history.current.query.c || (this.$router.history.current.query.callback && this.$router.history.current.query.callback.startsWith('connectLinkedInForPosting'))) {
          this.$router.push(this.$router.history.current.path);
          location.reload();
        } else {
          this.$router.push(this.$router.history.current.path);
        }
      }
    },
  },
  async mounted() {
    const { state } = this.user || {};
    const { linkedIn } = state || {};
    const { accessToken, expiresAt, version } = linkedIn || {};
    const now = new Date().getTime();
    const isLinkedInConnected = accessToken && expiresAt && expiresAt > now && version === 'v1';

    if (
      this.$route.query &&
      this.$route.query.hasOwnProperty('c') &&
      this.$route.query.c === this.entry.id
    ) {
      if (isLinkedInConnected) {
        this.$bvModal.show(`content-share-linkedin-post-editor-${this.$route.query.c}`);
      } else {
        this.$bvModal.show(`connect-linkedin-${this.$route.query.c}`);
      }
    }

    if (this.$route.query && this.$route.query.callback && !this.$route.hash.includes('error')) {
      const contentShareID = this.$route.query.callback.split(':')[1];
      if (contentShareID && contentShareID === this.entry.id) {
        this.$bvModal.show(`content-share-linkedin-post-editor-${contentShareID}`);
      }
    }
  },
  computed: {
    ...mapPreferences([ 'contentShareText', 'featuresEnabled' ]),
    ...mapRoot([ 'isEY', 'user', 'isPicnic', 'isOLX' ]),
    ...mapRoot({
      canShareJobsWith({ company }) {
        const { preferences, sitePreferences, sharePreferences } = company || {};
        const { canShareJobsWith } = { ...preferences, ...sitePreferences, ...sharePreferences };
        return canShareJobsWith;
      }
    }),
    postType() {
      return (this.entry && this.entry.customFields && this.entry.customFields.displayContent) || 'link';
    },
    hideHeader() {
      // at the moment this applies only for Picnic in case this page is loaded from comms
      return this.$route.query && this.$route.query.c && this.$route.query.comms === 'true' && this.isPicnic;
    },
    isLiConnected() {
      const { state } = this.user || {};
      const { linkedIn } = state || {};
      const { accessToken, expiresAt, version } = linkedIn || {};
      const now = new Date().getTime();
      const isLinkedInConnected = accessToken && expiresAt && expiresAt > now && version === 'v1';

      return isLinkedInConnected;
    },
    shareText() {
      const { customFields } = this.entry || {};
      return (customFields || {}).contentShareText || this.contentShareText;
    },
    defaultShareURL() {
      const { origin } = this.$root;
      const { shareCode } = this.entry;
      const { campaignID } = this;
      return `${origin}/c/${shareCode}${campaignID ? `?c=${campaignID}` : ''}`;
    },
    hasContentSharesV2Enabled() {
      return (this.featuresEnabled || []).includes('content-share-v2');
    },
    hasFacebookShareV2Enabled() {
      return (this.featuresEnabled || []).includes('facebook-share-v2');
    },
  },
};
</script>

<style lang="scss">
@import './../../scss/variables';

.content-card {
  .campaign-label {
    font-size: 11px;
    border-radius: 3px;
    color: #fff;
    display: inline-block;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content-share/ContentCard.vue